import React, { useEffect, useRef, useState } from "react";
import * as THREE from "three";
import { Volume2, VolumeX } from "lucide-react";

export default function FloatingLogo3D() {
  const mountRef = useRef(null);
  const audioRef = useRef(null);
  const [soundOn, setSoundOn] = useState(true);

  useEffect(() => {
  const audio = audioRef.current;
    if (!audio) return;

    audio.volume = 0.35;
    audio.loop = true;

    if (soundOn) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }, [soundOn]);

  useEffect(() => {
    const audio = audioRef.current;
    if (!audio) return;

    audio.volume = 0.35;
    audio.loop = true;

    if (soundOn) {
      audio.play().catch(() => {});
    } else {
      audio.pause();
    }
  }, [soundOn]);

  useEffect(() => {
    const mount = mountRef.current;
    if (!mount) return;

    const scene = new THREE.Scene();
    scene.background = new THREE.Color("#020202");

    const camera = new THREE.PerspectiveCamera(
      45,
      mount.clientWidth / mount.clientHeight,
      0.1,
      100
    );
    camera.position.set(0, 0.15, 6.1);

    const renderer = new THREE.WebGLRenderer({
      antialias: true,
      alpha: false,
    });

    renderer.setSize(mount.clientWidth, mount.clientHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    renderer.outputColorSpace = THREE.SRGBColorSpace;
    mount.appendChild(renderer.domElement);

    const group = new THREE.Group();
    scene.add(group);

    const ambientLight = new THREE.AmbientLight("#f7c948", 0.55);
    scene.add(ambientLight);

    const goldLight = new THREE.PointLight("#f7c948", 4.5, 14);
    goldLight.position.set(-3, 2.5, 4);
    scene.add(goldLight);

    const rimLight = new THREE.PointLight("#7a4f12", 2.2, 14);
    rimLight.position.set(0, -2.5, 3);
    scene.add(rimLight);

    const textureLoader = new THREE.TextureLoader();
    const logoTextures = ["/new-logo.png", "/logo.png.jpg", "/logo2.png"].map(src => {
    const texture = textureLoader.load(src);
      texture.colorSpace = THREE.SRGBColorSpace;
      texture.anisotropy = renderer.capabilities.getMaxAnisotropy();
      return texture;
    });

    let activeLogoIndex = 0;
    let lastLogoSwitch = 0;
    const LOGO_CHANGE_SECONDS = 30;

     const logoMaterial = new THREE.MeshBasicMaterial({
      map: logoTextures[activeLogoIndex],
      color: "#ffffff",
      transparent: true,
      opacity: 1,
      toneMapped: false,
    });

    const logoPlane = new THREE.Mesh(
      new THREE.PlaneGeometry(3.65, 3.65),
      logoMaterial
    );
    logoPlane.position.set(0, 0.65, 0.095);
    group.add(logoPlane);

    const applyLogoSize = index => {
      const widthScale = index === 0 ? 1.07 : 1;

      logoPlane.scale.set(widthScale, 1, 1);
    };

    applyLogoSize(activeLogoIndex);

    const starsGeometry = new THREE.BufferGeometry();
    const starCount = 420;
    const positions = [];
    const starSpeeds = [];

    for (let i = 0; i < starCount; i += 1) {
        positions.push(
            (Math.random() - 0.5) * 14,
            (Math.random() - 0.5) * 7,
            -2 - Math.random() * 8
        );

        starSpeeds.push(0.006 + Math.random() * 0.018);
        }

    starsGeometry.setAttribute(
      "position",
      new THREE.Float32BufferAttribute(positions, 3)
    );

    const stars = new THREE.Points(
        starsGeometry,
        new THREE.PointsMaterial({
            color: "#f8e7a1",
            size: 0.024,
            transparent: true,
            opacity: 0.9,
        })
        );
    scene.add(stars);

    const asteroidGroup = new THREE.Group();
    scene.add(asteroidGroup);

    const asteroidMaterial = new THREE.MeshStandardMaterial({
    color: "#15110a",
    metalness: 0.25,
    roughness: 0.72,
    emissive: "#020202",
    emissiveIntensity: 0.12,
    });

    const asteroids = [];

for (let i = 0; i < 16; i += 1) {
  const asteroid = new THREE.Mesh(
    new THREE.DodecahedronGeometry(0.08 + Math.random() * 0.16, 1),
    asteroidMaterial.clone()
    );

    asteroid.position.set(
        -7 + Math.random() * 14,
        -3.4 + Math.random() * 6.8,
        -2.5 - Math.random() * 5
    );

    asteroid.rotation.set(
        Math.random() * Math.PI,
        Math.random() * Math.PI,
        Math.random() * Math.PI
    );

    asteroid.userData = {
        speed: 0.012 + Math.random() * 0.025,
        spin: 0.008 + Math.random() * 0.02,
    };

    asteroids.push(asteroid);
    asteroidGroup.add(asteroid);
    }

    const clock = new THREE.Clock();
    const FRAME_INTERVAL = 1000 / 24;
    let lastFrameTime = 0;
    let animationFrameId = null;


    const animate = (now = 0) => {
      animationFrameId = requestAnimationFrame(animate);

      if (now - lastFrameTime < FRAME_INTERVAL) {
        return;
      }

      lastFrameTime = now;

      const elapsed = clock.getElapsedTime();

      if (elapsed - lastLogoSwitch >= LOGO_CHANGE_SECONDS) {
        lastLogoSwitch = elapsed;
        activeLogoIndex = (activeLogoIndex + 1) % logoTextures.length;
        logoMaterial.map = logoTextures[activeLogoIndex];

        if (activeLogoIndex === 2) {
          logoMaterial.color.set("#f7c948");
          logoMaterial.opacity = 0.92;
        } else {
          logoMaterial.color.set("#ffffff");
          logoMaterial.opacity = 1;
        }

        applyLogoSize(activeLogoIndex);
        logoMaterial.needsUpdate = true;
      }

      group.rotation.y = Math.sin(elapsed * 0.55) * 0.18;
      group.rotation.x = Math.sin(elapsed * 0.38) * 0.055;
      group.position.y = Math.sin(elapsed * 1.15) * 0.12;

      stars.rotation.y = elapsed * 0.018;

        const starPositions = starsGeometry.attributes.position.array;

        for (let i = 0; i < starCount; i += 1) {
        const index = i * 3;
        starPositions[index + 2] += starSpeeds[i];

        if (starPositions[index + 2] > 2) {
            starPositions[index] = (Math.random() - 0.5) * 14;
            starPositions[index + 1] = (Math.random() - 0.5) * 7;
            starPositions[index + 2] = -10;
        }
        }

        starsGeometry.attributes.position.needsUpdate = true;

        asteroids.forEach(asteroid => {
        asteroid.position.x += asteroid.userData.speed;
        asteroid.position.y += Math.sin(elapsed + asteroid.position.x) * 0.002;
        asteroid.rotation.x += asteroid.userData.spin;
        asteroid.rotation.y += asteroid.userData.spin * 0.7;

        if (asteroid.position.x > 7) {
            asteroid.position.x = -7;
            asteroid.position.y = -3.4 + Math.random() * 6.8;
            asteroid.position.z = -2.5 - Math.random() * 5;
        }
        });

      renderer.render(scene, camera);
    };

    animationFrameId = requestAnimationFrame(animate);

    const handleResize = () => {
      if (!mount) return;

      camera.aspect = mount.clientWidth / mount.clientHeight;
      camera.updateProjectionMatrix();
      renderer.setSize(mount.clientWidth, mount.clientHeight);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      window.removeEventListener("resize", handleResize);

      scene.traverse(object => {
        if (object.geometry) object.geometry.dispose();

        if (object.material) {
          if (Array.isArray(object.material)) {
            object.material.forEach(material => material.dispose());
          } else {
            object.material.dispose();
          }
        }
      });

      asteroidMaterial.dispose();
      logoTextures.forEach(texture => texture.dispose());
      renderer.dispose();

      if (renderer.domElement && mount.contains(renderer.domElement)) {
        mount.removeChild(renderer.domElement);
      }
    };
  }, []);

  return (
    <section className="relative mt-6 overflow-hidden rounded-xl border border-yellow-700/40 bg-[#020202]">
      <audio ref={audioRef} src="/nexovate-music.mp3" preload="auto" />

      <button
        type="button"
        onClick={() => setSoundOn(prev => !prev)}
        title={soundOn ? "Sound off" : "Sound on"}
        className="absolute right-5 top-5 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-yellow-500/40 bg-black/60 text-yellow-300 shadow-[0_0_18px_rgba(247,201,72,0.28)] hover:bg-yellow-500/10"
      >
        {soundOn ? <Volume2 size={20} /> : <VolumeX size={20} />}
      </button>

      <div className="px-6 pt-5">
        <p className="text-xs uppercase tracking-[0.35em] text-yellow-300">
          NEXOVATE GROUPS IDENTITY
        </p>
        <h2 className="mt-2 text-2xl font-bold text-yellow-200">
          The Next Innovations - "A chance to drift & float innovations"
        </h2>
      </div>

      <div
        ref={mountRef}
        className="floating-logo-stage w-full h-[620px]"
        style={{
          background:
            "radial-gradient(circle at center, rgba(247,201,72,0.10), rgba(2,2,2,1) 58%)",
        }}
      />
    </section>

    

  );
}